<template>
  <colgroup>
    <col
      v-for="(column, idx) in columns"
      :key="idx"
      :name="`col_${idx + 1}`"
      :style="{ width: column.width }"
    />
  </colgroup>
</template>
<script>
export default {
  name: "grid-col-group",
  props: {
    columns: {
      type: Array,
    },
  },
};
</script>
